import {
  TopBannerColorScheme,
  TopBannerStrapiProps,
  UnifiedTopBannerProps,
} from '@/blocks/topBanner/types';
/**
 * discriminates between the different types of top banner props
 *
 * One is legacy.
 *
 * One is new.
 *
 * Noone knows which one is actually used. Keep until we get to clean this mess  up.
 */
export const getBannerIsStrapiWrappedBanner = (
  block: UnifiedTopBannerProps
): block is TopBannerStrapiProps => {
  return 'top_banner_elements' in block;
};

export const getBannerColorScheme = (
  colorScheme: TopBannerColorScheme = 'brand-dark'
): {
  bannerBg: `bg-${string} dark:bg-${string}`;
  text: `text-${string} dark:text-${string}`;
  badgeBg: `bg-${string} dark:bg-${string}`;
  badgeText: `text-${string} dark:text-${string}`;
  ctaText: `text-${string} dark:text-${string}`;
  countdownBg: `bg-${string} dark:bg-${string}`;
  countdownText: `text-${string} dark:text-${string}`;
} => {
  switch (colorScheme) {
    case 'brand-light':
      return {
        bannerBg: 'bg-brand-500 dark:bg-brand-500',
        text: 'text-base-white dark:text-base-dark-white',
        badgeText: 'text-brand-700 dark:text-brand-700',
        badgeBg: 'bg-brand-100 dark:bg-brand-100',
        ctaText: 'text-base-white dark:text-base-dark-white',
        countdownBg: 'bg-brand-800 dark:bg-brand-800',
        countdownText: 'text-base-white dark:text-base-dark-white',
      };

    case 'iridescent':
      return {
        bannerBg:
          'bg-gradient-main-semi-transparent dark:bg-gradient-main-semi-transparent',
        badgeText: 'text-base-white dark:text-base-dark-white',
        text: 'text-base-black dark:text-base-dark-black',
        badgeBg: 'bg-gray-900 dark:bg-gray-900',
        ctaText: 'text-base-black dark:text-base-dark-black',
        countdownBg: 'bg-secondary-100 dark:bg-secondary-100',
        countdownText: 'text-base-white dark:text-base-dark-black',
      };
    case 'brand-dark':
    default:
      return {
        bannerBg: 'bg-brand-950 dark:bg-brand-950',
        text: 'text-base-white dark:text-base-dark-white',
        badgeText: 'text-base-white dark:text-base-dark-white',
        badgeBg: 'bg-gradient-secondary-1 dark:bg-gradient-secondary-1',
        ctaText: 'text-base-white dark:text-base-dark-white',
        countdownBg: 'bg-brand-975 dark:bg-brand-975',
        countdownText: 'text-base-white dark:text-base-dark-white',
      };
  }
};
